
import Meta from '~/mixins/meta'
import { offset } from '~/node_modules/highcharts/highcharts';

export default {
  name: 'ProductIvestor',
  layout: 'ivestor',
  fetchOnServer: false,

  head() {
    return {
      title: 'iVestor',
      titleTemplate: this.$t('page-meta.title'),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('page-meta.desc'),
        },
        {
          hid: 'og-title',
          property: 'og:title',
          content: this.$t('page-meta.title'),
        },
        {
          hid: 'og-type',
          property: 'og:type',
          content: 'website',
        },
        {
          hid: 'og-description',
          property: 'og:description',
          content: this.$t('page-meta.desc'),
        },
        {
          hid: 'og-url',
          property: 'og:url',
          content: `https://www.dfm.ae/${this.$route.path}`,
        },
        {
          hid: 'og-image',
          property: 'og:image',
          content: `${this.$config.headImage}${this.$t('page-meta.image')}`,
        },
        {
          hid: 'twitter-title',
          property: 'twitter:title',
          content: this.$t('page-meta.title'),
        },
        {
          hid: 'twitter-description',
          property: 'twitter:description',
          content: this.$t('page-meta.desc'),
        },
        {
          hid: 'twitter-image',
          property: 'twitter:image',
          content: `${this.$config.headImage}${this.$t('page-meta.image')}`,
        },
        {
          hid: 'twitter-card',
          property: 'twitter:card',
          content: 'summary',
        },
      ],
    };
  },

  data() {
    return {
      showModal: false,
      // faqs: this.$t('faqs'),
    }
  },
  mounted() {

    if (this.$route.path === '/investing/services/ivestor/signup-form') {
      this.showModal = true
    }
    if (this.$route.hash == '#faqs') {
      const myEl = this.$refs.faqs
      this.$smoothScroll({
        scrollTo: myEl,
        offset: -100, // Adjust the offset as needed
      })
    }
  },
  computed: {
    currentYear() {
      return new Date().getFullYear()
    },
    availableLocales() {
      return this.$i18n.locales.filter((i) => i.code !== this.$i18n.locale)
    },
    arenaVideo() {
      return {
        "thumbText": "Watch Video",
        "videoId": "1080095897",
        "videoThumb": "thumbnails/ivestor-appshowcase-video-thumb",
        "videoTitle": "iVestor App Showcase",
      }
    },
  },
  methods: {
    openBetaForm() {
      this.$refs.betaForm.showModal = true
    },
    formSubmitted() {
      // this.$refs.betaForm.showModal = false
      this.showModal = false
    },
    testMethod() {
      console.log('test')
    },
  },

}
